var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPostalCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1661_180437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9531 20.2031V11.8125C11.9531 9.4402 9.98953 6.79688 7.17188 6.79688H6.9375C4.17188 6.79688 1.92188 9.04688 1.92188 11.8125V19.5C1.92188 19.8883 2.23669 20.2031 2.625 20.2031H11.9531Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0625 6.79688H16.3594V10.125C16.3594 10.5133 16.0446 10.8281 15.6563 10.8281C15.268 10.8281 14.9532 10.5133 14.9532 10.125C14.9532 9.5633 14.9532 5.97141 14.9532 5.20312H19.5C20.0459 5.20312 20.3837 4.60622 20.1029 4.13827L19.1923 2.62059L20.1068 1.05834C20.3807 0.590531 20.0428 0 19.5 0H14.25C13.8617 0 13.5469 0.314812 13.5469 0.703125V6.79688H10.9729C12.4864 8.06503 13.3594 9.96305 13.3594 11.8125V20.2031H21.375C21.7633 20.2031 22.0782 19.8883 22.0782 19.5V11.8125C22.0782 9.04688 19.8282 6.79688 17.0625 6.79688Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5469 21.6094V23.2969C10.5469 23.6852 10.8617 24 11.25 24H14.25C14.6383 24 14.9531 23.6852 14.9531 23.2969V21.6094H10.5469Z",
    fill: "#8A8A8A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1661_180437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostalCode);
export default __webpack_public_path__ + "static/media/postal_code.d1442fc7.svg";
export { ForwardRef as ReactComponent };